import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import Welcome from './Welcome'
import Start from './Start'
import Subjects from './Subjects'
import './index.less'

class SubjectChoice extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route exact path={`${match.url}/welcome`} component={Welcome}></Route>
        <Route exact path={`${match.url}/start`} component={Start}></Route>
        <Route exact path={`${match.url}/subjects/:province`} component={Subjects}></Route>
        <Redirect from={`${match.url}`} to={`${match.url}/welcome`}></Redirect>
      </Switch>
    );
  }
}

export default SubjectChoice;


// WEBPACK FOOTER //
// ./src/pages/SubjectChoice/index.js